module.exports = __webpack_public_path__ + "img/hzfp29.78738fca.png";